import { useState } from "react";

export type ZoomData = {
  active: boolean;
  x: number;
  y: number;
  xAffiche: number;
  yAffiche: number;
};

export function useZoomLoupe() {
  const [zoomData, setZoomData] = useState<ZoomData>({
    active: false,
    x: 0,
    y: 0,
    xAffiche: 0,
    yAffiche: 0,
  });

  return { zoomData, setZoomData };
}
